import { Component, HostListener, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth';

@Component({
  selector: 'app-header',
  imports: [CommonModule, RouterModule],
  templateUrl: './header.html',
  styleUrl: './header.css',
})
export class Header {
  user = computed(() => this.authService.currentUser());
  isDropdownOpen = signal(false);

  constructor(private authService: AuthService) {}

  toggleDropdown(): void {
    this.isDropdownOpen.update(v => !v);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const dropdown = document.getElementById('userMenuDropdown');
    const button = document.getElementById('userMenuButton');

    if (dropdown && button && !dropdown.contains(target) && !button.contains(target)) {
      this.isDropdownOpen.set(false);
    }
  }

  logout(): void {
    this.isDropdownOpen.set(false);
    this.authService.logout();
  }
}
